import { cx } from "@jugl-web/utils";
import type { AnimationItem } from "lottie-web";
import { useEffect, useRef, type FC } from "react";
import LottiePlayer from "react-lottie-player";
import animationData from "./assets/animation.json";

interface VoiceOrbAnimationProps {
  isActive: boolean;
  isFaded: boolean;
}

export const VoiceOrbAnimation: FC<VoiceOrbAnimationProps> = ({
  isActive,
  isFaded,
}) => {
  const animationItemRef = useRef<AnimationItem>(null);

  // Adjust speed of the animation based on the active state
  useEffect(() => {
    if (!animationItemRef.current) {
      return;
    }

    animationItemRef.current.setSpeed(isActive ? 1 : 0.5);
  }, [isActive]);

  return (
    <div className="animate-slide-up-from-below">
      <div
        className={cx(
          "size-50 transition-[opacity,scale,filter] duration-300 ease-out",
          isFaded
            ? "scale-80 opacity-40 saturate-40"
            : isActive
              ? "scale-140 opacity-100 saturate-100"
              : "scale-100 opacity-100 saturate-100"
        )}
      >
        <div
          className={cx(isActive && "animate-pulse-scale")}
          style={{
            animationDuration: "1.2s",
            animationDelay: "300ms",
          }}
        >
          <LottiePlayer
            ref={animationItemRef}
            animationData={animationData}
            loop
            play
          />
        </div>
      </div>
    </div>
  );
};
